import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from 'services/api/config/api';
import { clearScopedTenantId } from 'services/api/config/scopedTenant';
import { Button } from 'common/components/Button';
import styles from './NoPlatformAccess.module.scss';

// Where somebody signed in without a Platform role lands: a person of another
// SLAI product only — a Voice Recorder talent in a company, or somebody who
// signed up for TTS on their own and is in no company at all. It makes no
// Platform call but the logout, which the API lets through.
const NoPlatformAccess: React.FC = () => {
    const navigate = useNavigate();
    const [signingOut, setSigningOut] = useState(false);

    const handleSignOut = async () => {
        setSigningOut(true);
        try {
            clearScopedTenantId();
            await api.post('/auth/logout');
        } catch (error) {
            console.error('Logout error:', error);
        }
        navigate('/login');
    };

    return (
        <div className={styles.page}>
            <div className={styles.card}>
                <h1>No access to the Platform</h1>
                <p>
                    This account has no role on the Platform. It may be an account for another SLAI product, such as
                    Voice Recorder or TTS. If you need the Platform, ask your company&apos;s administrator for a
                    Platform role.
                </p>
                <Button variant='primary' onClick={handleSignOut} disabled={signingOut}>
                    Sign out
                </Button>
            </div>
        </div>
    );
};

export default NoPlatformAccess;
